<div class="container-fluid mt-2">
    <mat-card class="bg-warning text-dark">
        <mat-card-header>
            <div mat-card-avatar class="example-header-image"></div>
          <mat-card-title><strong> {{data.childName}}</strong></mat-card-title>
          <mat-card-subtitle><strong> {{data.centreName}}</strong>  </mat-card-subtitle>
        </mat-card-header>
<!--      <prettyjson [obj]="data"></prettyjson>-->
        <mat-card-content>

            <div class="d-flex justify-content-between ">
              <div>Hometown: <strong> {{data.city}}</strong></div>
              <div>Session Type:<strong> {{data.type}}</strong></div>


              <!--  <div>Parents Name: {{data.city}}</div>-->


            </div>
            <div class="d-flex justify-content-between ">
                <!--      <div>Hometown: {{data.city}}</div>-->
                <div>Parents Name:<strong> {{data.parentsName}}</strong></div>

                <!--      <div>Conducted By: {{data.personConductingTest}}</div>-->
              <div>Designation: <strong> {{data.designation}}</strong></div>
            </div>
          <div class="d-flex justify-content-between ">
                <!--      <div>Hometown: {{data.city}}</div>-->
            <div>Conducted By:<strong> {{data.personConductingTest}}</strong></div>
            <!--  <div>Designation: {{data.designation}}</div>-->

            <div>DOA: <strong> {{data.dateOfAdmission?.toDate()|date}}</strong></div>

          </div>
            <div class="d-flex justify-content-end ">
                <div>Date of Assessment <strong> {{data.dateOfAssessment?.toDate()|date}}</strong></div>
            </div>
        </mat-card-content>
    </mat-card>
<div class="row">
<div class="col-md-6">
    <table class="list-group mt-2 ">
        <ng-container *ngFor=" let d of data.assessment;let i =index">
            <div class="list-group-item list-group-item-secondary mb-2 rounded bg-light text-dark">
                <tr>
                    <td>{{d.q}}</td>
                </tr>
                <tr>
                    <th class="btn bg-warning text-dark rounded-pill">{{d.ans}}</th>
                </tr>
            </div>
        </ng-container>
    </table>
</div>
  <div class="col-md-6">
    <canvas baseChart
            [labels]="doughnutChartLabels"
            [datasets]="chartconfigurationsArray[0]"
            [options]="doughnutChartOptions"
            [legend]="true"
            [type]="'doughnut'" >
    </canvas>&nbsp;
      <h3>
          Total Not Able to Coping up {{totalYes}} <br>
          Total Able to Coping up {{totalNo}} <br>
          Total Difficulty in Coping up {{totalSometimes}}
      </h3>

  </div>
</div>

  <div class="col-md-12">
    <h2 class="rounded  text-center bg-warning text-dark">Documents & Uploads</h2>
    <!--            <h3>Data will be uploaded to {{mStoragePath}} in {{mDbType}} at {{mPath}} </h3>-->
    <div class="col-md-6">
      <app-file-upload [storagePath]="mStoragePath" [dbPath]="mPath" fileCount="multi"></app-file-upload>
    </div>  <!--            <app-upload [dbType]="mDbType" [path]="mPath" [storagePath]="mStoragePath" ></app-upload>-->
  </div>
  <div>
    <h3>Uploaded Documents</h3>
    <!--                  <prettyjson [obj]="data"></prettyjson>-->
    <!--         COPY-->
    <div class="cdk-virtual-scroll-data-source-example">
      <cdk-virtual-scroll-viewport orientation="horizontal" itemSize="5" class="example-viewport">
        <div class="d-flex  flex-row">
          <div *cdkVirtualFor="let d of (mDocuments);trackBy:trackByMethod;let i = index" class="example-item ">
            <a (click)="openLink(d.url)">
              <img [src]="d.url" style="width: 250px; height: 250px" class="img-thumbnail img-fluid">
            </a>
            <p style="flex-grow: 9; font-size: 14px" class="text-center">{{d.description}}</p>
            <button mat-icon-button color="warn" (click)="deleteAdmissionFile(i,d,'documents')">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>

<!--  <prettyjson [obj]="documents$|async"></prettyjson>-->


    <div class="text-center">
        <button mat-raised-button color="primary" class="mt-2" (click)="close()">Close</button>
    </div>
</div>
